import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { MasterRole } from '@chernova/shared';

export interface MasterInfo {
  id: string;
  telegram_id: string | null;
  telegram_username?: string | null;
  name: string;
  role: MasterRole;
  photo_url?: string | null;
  phone?: string | null;
  timezone?: string;
  working_hours?: Record<string, { from: string | null; to: string | null }> | null;
}

type Scope = 'me' | 'worker' | 'all' | string; // string => specific master_id

interface AuthState {
  token: string | null;
  master: MasterInfo | null;
  scope: Scope;
  setAuth: (token: string, master: MasterInfo) => void;
  setScope: (s: Scope) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      master: null,
      scope: 'me',
      setAuth: (token, master) => set({ token, master }),
      setScope: (scope) => set({ scope }),
      clear: () => set({ token: null, master: null, scope: 'me' }),
    }),
    { name: 'chernova-auth' },
  ),
);
